var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturerDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 400 450",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Pharmaceutical Brand Default Image") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Default placeholder for pharmaceutical manufacturers and brands with various pharma symbols"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A1715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#162C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1E4A46"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "plusPattern",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 6,
    height: 20,
    rx: 2,
    fill: "#FFFFFF",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 20,
    height: 6,
    rx: 2,
    fill: "#FFFFFF",
    opacity: 0.04
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#bgGrad)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#plusPattern)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 90,
    rx: 150,
    ry: 150,
    fill: "#5FBDB3",
    opacity: 0.08,
    filter: "blur(60px)",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.08,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 310,
    rx: 130,
    ry: 130,
    fill: "#FF601E",
    opacity: 0.06,
    filter: "blur(50px)",
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.06,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 55,
    fill: "#1E4A46",
    stroke: "#5FBDB3",
    strokeWidth: 3,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 172,
    width: 24,
    height: 56,
    rx: 4,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 188,
    width: 56,
    height: 24,
    rx: 4,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 105)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -15,
    width: 12,
    height: 30,
    rx: 6,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -15,
    width: 12,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: 0,
    x2: 12,
    y2: 0,
    stroke: "#1E4A46",
    strokeWidth: 2.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(30, 74, 70)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270, 130)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: -6,
    r: 3.5,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: -6,
    r: 3.5,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: 6,
    r: 3.5,
    fill: "#FFFFFF",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3.5,
    fill: "#FFFFFF",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: -6,
    x2: 6,
    y2: 6,
    stroke: "#5FBDB3",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -6,
    x2: -6,
    y2: 6,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(295, 200)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -6,-12 L -6,-4 L -10,8 Q -10,12 0,12 Q 10,12 10,8 L 6,-4 L 6,-12 Z",
    fill: "#FFFFFF",
    stroke: "#5FBDB3",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -14,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#FF601E",
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cy: 6,
    rx: 6,
    ry: 3,
    fill: "#5FBDB3",
    opacity: 0.4,
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270, 270)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 14,
    fill: "#FFFFFF",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: 0,
    x2: 10,
    y2: 0,
    stroke: "#5FBDB3",
    strokeWidth: 2.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -10,
    x2: 0,
    y2: 10,
    stroke: "#5FBDB3",
    strokeWidth: 2.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 295)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -2,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#FFFFFF",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -8,
    width: 6,
    height: 8,
    rx: 1,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: -12,
    width: 6,
    height: 12,
    rx: 1,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 8,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#FF601E",
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 270)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10,2 Q -10,10 0,10 Q 10,10 10,2 Z",
    fill: "#FFFFFF",
    stroke: "#5FBDB3",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: 0,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2,-8 L 6,-12 L 8,-10 L 4,-6 Z",
    fill: "#FF601E",
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105, 200)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -10,
    width: 16,
    height: 18,
    rx: 4,
    fill: "#FFFFFF",
    stroke: "#5FBDB3",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(95, 189, 179)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -14,
    width: 10,
    height: 5,
    rx: 2,
    fill: "#FF601E",
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -2,
    width: 14,
    height: 6,
    rx: 1,
    fill: "#5FBDB3",
    opacity: 0.3,
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 130)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "#1E4A46",
    opacity: 0.7,
    style: {
      fill: "rgb(30, 74, 70)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -12,
    width: 4,
    height: 20,
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -8,-8 L 4,-8 L 4,-12 L -8,-12 Z",
    fill: "#5FBDB3",
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 10,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#FFFFFF",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 365,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle",
    opacity: 0.6,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "Arial, sans-serif",
      fontSize: 14,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "\r\n    Pharmaceutical Brand\r\n  "), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 3,
    fill: "#5FBDB3",
    opacity: 0.25,
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 35,
    r: 3,
    fill: "#5FBDB3",
    opacity: 0.25,
    style: {
      fill: "rgb(95, 189, 179)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 365,
    r: 3,
    fill: "#FF601E",
    opacity: 0.25,
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 365,
    r: 3,
    fill: "#FF601E",
    opacity: 0.25,
    style: {
      fill: "rgb(255, 96, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturerDefault);
export default __webpack_public_path__ + "static/media/manufacturer_default.03fa3fb9966f51553a35262784e15e34.svg";
export { ForwardRef as ReactComponent };